module.exports = __webpack_public_path__ + "img/21.7b8a2ec7.gif";